import React, { useState, useEffect } from 'react';
import { Modal, Form, Button } from 'react-bootstrap';
import HourSelector from '../../../../../../../../components/common/HourSelector/HourSelector';
import './InHouse.scss';

interface InHouseProps {
  setViewMode: any;
  setOrderContext: (orderContext: any) => void;
  handleClose: () => void;
  show: boolean;
}

const InHouse: React.FC<InHouseProps> = ({
  setViewMode,
  setOrderContext,
  handleClose,
  show
}) => {
  const [localClientName, setLocalClientName] = useState<string>('');
  const [localHoraEntrega, setLocalHoraEntrega] = useState<string>('');
  const [selectedQuickTime, setSelectedQuickTime] = useState<string>('');

  useEffect(() => {
    if (!show) {
      setViewMode('select');
      setLocalClientName('');
      setLocalHoraEntrega('');
      setSelectedQuickTime('');
      setOrderContext({});
    }
  }, [show, setViewMode, setOrderContext]);

  const handleQuickTimeSelect = (minutes: number, label: string) => {
    const now = new Date();
    const totalMinutes = now.getHours() * 60 + now.getMinutes() + minutes;
    
    // Calculate new hours and minutes
    const newHours = Math.floor(totalMinutes / 60) % 24;
    const newMinutes = totalMinutes % 60;
    
    // Round minutes to nearest 5-minute interval
    const roundedMinutes = Math.round(newMinutes / 5) * 5;
    
    // Handle minute overflow (if rounding goes to 60)
    const finalHours = roundedMinutes >= 60 ? (newHours + 1) % 24 : newHours;
    const finalMinutes = roundedMinutes >= 60 ? 0 : roundedMinutes;
    
    const timeString = `${finalHours.toString().padStart(2, '0')}:${finalMinutes.toString().padStart(2, '0')}`;
    
    setLocalHoraEntrega(timeString);
    setSelectedQuickTime(label);
  };

  const handleSubmit = (e: React.FormEvent | React.MouseEvent) => {
    if ('preventDefault' in e) e.preventDefault();
    const today = new Date().toISOString().split('T')[0];
    const formattedHoraEntrega = `${today}T${localHoraEntrega}:00`;
    const orderContext = {
      client_id: null,
      client_name: localClientName,
      mesa_id: null,
      mesa_num: null,
      hora_entrega: formattedHoraEntrega,
      priority: null,
    };
    setOrderContext(orderContext);
    setViewMode('order');
  };

  return (
    <>
      <Modal.Body className="form-section in-house-section">
        <Form>
          <Form.Group controlId="clientName" className="mp-formgroup horizontal">
            <Form.Label>Nombre del Cliente</Form.Label>
            <Form.Control
              type="text"
              placeholder="Ingrese el nombre del cliente"
              value={localClientName}
              onChange={(e) => setLocalClientName(e.target.value)}
            />
          </Form.Group>

          <Form.Group controlId="horaEntrega" className="mp-formgroup horizontal">
            <Form.Label>Hora de Entrega</Form.Label>
            <HourSelector
              id="horaEntrega"
              value={localHoraEntrega}
              onChange={(time) => {
                setLocalHoraEntrega(time);
                setSelectedQuickTime('');
              }}
              disabled={false}
              allowPrev={false}
            />
          </Form.Group>

          {!localHoraEntrega && (
            <div className="quick-time-section">
              <label className="quick-time-label">Selección Rápida</label>
              <div className="quick-time-buttons">
              <button
                type="button"
                className={`quick-time-btn ${selectedQuickTime === '15min' ? 'active' : ''}`}
                onClick={() => handleQuickTimeSelect(15, '15min')}
              >
                15 min
              </button>
              <button
                type="button"
                className={`quick-time-btn ${selectedQuickTime === '30min' ? 'active' : ''}`}
                onClick={() => handleQuickTimeSelect(30, '30min')}
              >
                30 min
              </button>
              <button
                type="button"
                className={`quick-time-btn ${selectedQuickTime === '45min' ? 'active' : ''}`}
                onClick={() => handleQuickTimeSelect(45, '45min')}
              >
                45 min
              </button>
              <button
                type="button"
                className={`quick-time-btn ${selectedQuickTime === '1h' ? 'active' : ''}`}
                onClick={() => handleQuickTimeSelect(60, '1h')}
              >
                1 hora
              </button>
            </div>
          </div>
          )}
        </Form>
      </Modal.Body>

      <Modal.Footer>
        <div className="form-modal-footer-custom">
          <Button variant="none" className="form-button-cancel" onClick={handleClose}>
            Cancelar
          </Button>
          <Button className="form-button-create"
           variant="none"
            onClick={handleSubmit}
            disabled={!localClientName || !localHoraEntrega}>
            Tomar Orden
          </Button>
        </div>
      </Modal.Footer>
    </>
  );
};

export default InHouse;
